import React, { useState } from "react";
import { TabHeader } from "components/TabHeader";
import { useRoles } from "newui/features/RolesPermissions/hooks/useRoles";
import { RolesList } from "./RolesList";
import { PermissionMatrixEditor } from "./PermissionMatrixEditor";

export interface RolesPermissionsPageProps {
	path?: string;
}

export const RolesPermissionsPage = (_props: RolesPermissionsPageProps) => {
	const { data: roles } = useRoles();
	const [selectedRoleId, setSelectedRoleId] = useState<number | undefined>(undefined);

	return (
		<div data-testid="roles-permissions-page">
			<TabHeader heading="Roles & Permissions" description="Manage roles and the permission matrix for your company." />

			<div className="mt-5 grid grid-cols-1 gap-6 lg:grid-cols-[320px_1fr]">
				<div>
					<h3 className="mb-2 text-sm font-semibold text-gray-700">Roles</h3>
					<RolesList selectedRoleId={selectedRoleId} onSelectRole={setSelectedRoleId} />
				</div>

				<div>
					<h3 className="mb-2 text-sm font-semibold text-gray-700">Permission matrix</h3>
					<PermissionMatrixEditor roles={roles} highlightedRoleId={selectedRoleId} />
				</div>
			</div>
		</div>
	);
};
